module.exports = __webpack_public_path__ + "assets/img/list.3c1b00be.jpg";